
/**
 * 移动端Hybird接口
 * @readonly
 * @enum {string}
 */
export const MOBILE_API = {
    /**
     * 关闭当前窗口
     * @param {string} refresh 判断是否需要刷新之前页面
     */
    EXIT: 'hybird://method/exit',
    /**
     * 端上分享接口
     * @param {string} platform 平台(WX, WXCircle, QQ, QQZone)
     * @param {string} data JSON格式的数据
     * @param {string} jsCallBack 回调函数名,一个全局函数,回调参数("success"完成分享, "fail"分享失败, "cancel"取消分享)
     */
    SHARE_URL: 'hybird://method/doShare',
    /**
     * 打开一个Native窗口
     * @param {string} url 要打开的窗口地址
     * @param {string} title 要打开的窗口名称
     */
    OPEN_NEW_WINDOW_URL: 'hybird://method/openNewWindow',
    /**
     * 打开用户默认浏览器
     * @param {string} url 浏览器默认打开的地址
     */
    OPEN_BROWSER_URL: 'hybird://method/openBrowser',
    /**
     * 隐藏顶部导航栏
     */
    HIDE_TITLE_BAR: 'hybird://method/hideTitleBar',
    /**
     * 设置顶部导航栏
     */
    SET_TITLE: 'hybird://method/setTitle',
    /** 
     *调用支付页面
     */
    PAYCENTER: 'hybird://method/pay',

    /**
     * 获取网络状态 getNetworkStatus
     */
    GET_NETWORK_STATUS: 'hybird://method/getNetworkStatus',

    /**
     * 获取家长端版本 getAppVersion
     */
    GET_APP_VERSION: 'hybird://method/getAppVersion',

    /**
     * 学生端 打开或下载家长端App openParentClient
     */
    OPEN_PARENT_CLIENT: 'hybird://method/openParentClient',

    /**
     * 学生端
     */
    // 练习本
    OPEN_MAIN_HOMEWORK_TAB: 'hybird://method/openMainHomeWorkTab',
    // 加入班级
    ADD_CLASS_GROUP: 'hybird://method/addClassGroup',

    /**
     * 老师端
     */
    // 发布页面
    GOTO_PUBLISH: 'hybird://method/gotoPublish',
    // 练习首页
    GOTO_HOMEWORK: 'hybird://method/gotoHomework',
    // 加班/建班页
    GOTO_CLASS_GROUP: 'hybird://method/gotoClassGroup',
    // 教师资格认证
    AUTHENTICATION: 'hybird://method/Authentication',

    // 课件库
    courseLibrary: 'hybird://method/courseLibrary',
    // 活动列表页
    activitiesList: 'hybird://method/activitiesList',
    // 国家资源教育平台
    nationalPlatformMatchSchool: 'hybird://method/nationalPlatformMatchSchool',
    //布克听世界
    openBukeListeningHomePage: 'hybird://method/openBukeListeningHomePage',
    //我的课程
    myclass: 'hybird://method/myclass',
    // ios恢复购买
    RESTORE_PRODUCT: 'hybird://method/restoreProduct',

    CALCULATION_EXERCISE:'hybird://method/openRapidCalculationExercise',         // 速算练习

    SELF_COLLEGE:'hybird://method/openSelfStudyIntroduction?type=0',    //魔法学院

    SELF_IDIOM:'hybird://method/openSelfStudyIntroduction?type=2',    //成语学堂

    SELF_STUDY:'hybird://method/openSelfStudyIntroduction?type=4',    //学霸计划

    SYNC_ROOT_LIST:'hybird://method/openSyncRootListPage',           //同步练

    SELF_AUDIO:'hybird://method/openSelfStudyPage?pageIndex=1',               //音频

    SELF_BOOK:'hybird://method/openSelfStudyPage?pageIndex=2',               //绘本

    SELF_VIDEO:'hybird://method/openSelfStudyPage?pageIndex=3',               //视频
    SELF_DOTREAD:'hybird://method/toDotRead',//点读
};